module.exports = __webpack_public_path__ + "img/ace-of-spades.c3617559.png";